// extracted by mini-css-extract-plugin
export var standaloneTable = "_er-0";
export var standaloneTableWithBodyFill = "_er-1";
export var withExtraHeader = "_er-2";